export const formatSpringName = (name: string, width: number, length: number, thicknesses: number[]) => {
  const SPRING_DIMENSION_REGEX = /(.*\d+(?:\,\d+)?x\d+(?:\,\d+)?x\d+(?:\,\d+)?)\s(.+)/;
  const match = name.match(SPRING_DIMENSION_REGEX);
  console.info(`## formatSpringName: ${name} : ${JSON.stringify(match)}`);
  if (match === null) {
    return `${name} (${width}x${length})`;
  } else {
    const springDimension = match[1];
    const nameExpansion = match[2];
    const thicknessFormatted = thicknesses.length === 0 ? null : Array.from(new Set(thicknesses)).join(' i ');
    const thicknessExcerpt = thicknessFormatted === null ? '' : ` / [${thicknessFormatted}]`;
    return `${springDimension} (${width}x${length})${thicknessExcerpt} ${nameExpansion}`;
  }
};